import type { SheetBodyProps } from './Sheet.types'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import cn from 'classnames'
import * as React from 'react'
import { SheetContext } from './context'
import styles from './Sheet.module.css'

export function Body({
  side = 'right',
  hasPadding = true,
  bottomSideInMobile = true,
  onChange,
  children,
}: SheetBodyProps) {
  const [contentElement, setContentElement] = React.useState<HTMLDivElement | null>(null)

  const isRight = side === 'right'
  const isLeft = side === 'left'
  const isBottom = side === 'bottom'

  // For right/left sides, mobile-bottom behaviour is conditional on `bottomSideInMobile`.
  // We apply `mobileBottom` or `noMobileBottomRadius` classes which are activated inside
  // the `@media (--media-breakpoint-s-max)` rule in the CSS module.
  const mobileBottomClass = !isBottom
    ? bottomSideInMobile
      ? styles.mobileBottom
      : styles.noMobileBottomRadius
    : null

  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className={styles.backdrop} />
      <DialogPrimitive.Content
        className={cn(
          styles.bodyWrapper,
          {
            [styles.sideRight]: isRight,
            [styles.sideLeft]: isLeft,
            [styles.sideBottom]: isBottom,
          },
          mobileBottomClass,
          !hasPadding && styles.noPadding,
        )}
        onChange={onChange}
        aria-describedby=""
      >
        <SheetContext value={{ contentElement, setContentElement }}>
          {children}
        </SheetContext>
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  )
}
